export function tourDetailSlider() {
    $('.entry-detail-slider').slick({
        speed: 500,
        slidesToShow: 1,
        dots: false,
        arrows: true,
        infinite: false,
    });

    $.fn.extend({
        toggleText: function (a, b) {
            return this.text(this.text() == b ? a : b);
        }
    });


    $(function () {
        $('.slick-next').on('click', function () {
            var slider = $('.tour-detail-slider');
            var currentSlide = slider.slick('slickCurrentSlide')
            var totalSlides = slider.data('image-length');
            if (currentSlide + 1 === totalSlides) {
                $('.tour-detail-slider').slick('slickGoTo', 0, true);
            }
        });

        $('.slick-next').on('click', function () {
            var slider = $('.tour-detail-slider');
            var currentSlide = slider.slick('slickCurrentSlide')
            var totalSlides = slider.data('image-length');
            if (currentSlide + 1 === totalSlides) {
                $('.tour-detail-slider').slick('slickGoTo', 0, true);
            }
        });


        $('.tour-detail-page').addClass('loaded');
        $('[data-fancybox="gallery"]').fancybox({
            thumbs: {
                autoStart: true, // Display thumbnails on opening
                hideOnClose: true, // Hide thumbnail grid when closing animation starts
                parentEl: ".fancybox-container", // Container is injected into this element
                axis: "y" // Vertical (y) or horizontal (x) scrolling
            },
        });

        var bookingBox = $('.sidebar-wrapper').offset().top - 30;

        $(window).scroll(function () {
            var windowTop = $(window).scrollTop();

            var isSimilarTours = $('.similar-tours-section').length ? $('.similar-tours-section').isInViewport() : false;

            if ((bookingBox < windowTop) && !isSimilarTours) {
                $('.sidebar-wrapper').addClass('sticked');
            }
            else {
                $('.sidebar-wrapper').removeClass('sticked');
            }
        });

        $('.book-now').click(function () {
            $('html,body').animate({
                scrollTop: $('.book-online').offset().top - 150
            }, 'slow');
        });

        $('.show-more-button').click(function () {
            $(this).parents('.wrapper-holder').toggleClass('passive');
            $(this).toggleText('Show more', 'Show less');
        });
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/tourDetailSlider.js